import { useState } from 'react';
import { Form, Toast, ToastContainer } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { useAuth } from 'providers/AuthProvider'
import apiClient, { handleAPIError } from 'helpers/apiService';
import Button from 'components/base/Button';
import { useNavigate } from 'react-router-dom';


const SettingsChangePassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const auth = useAuth();

  const [loading, setLoading] = useState(false);
  // State to control Toast messages
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  type Errors = {
    password?: string,
    password2?: string,
    oldPassword?: string
  }

  const [errors, setErrors] = useState<Errors>({});

  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");

  // Function to handle input changes
  const handleInputOldPwd = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setOldPassword(value);
  };


  const handleInputChangePwd1 = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setPassword(value);
  };
  const handleInputChangePwd2 = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setPassword2(value);
  };

  const validateForm = (): boolean => {
    const newErrors: Errors = {};
    let isValid = true;

    if (oldPassword === "") {
      newErrors.oldPassword = 'Password cannot be empty';
      isValid = false;
    }

    if (password === "") {
      newErrors.password = 'Password cannot be empty';
      isValid = false;
    }

    if (password2 === "") {
      newErrors.password2 = 'Password cannot be empty';
      isValid = false;
    }

    if (password !== password2) {
      newErrors.password2 = 'Passwords do not match';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async () => {

    if (validateForm() == false) {
      return
    }

    setLoading(true);
    const formData = new FormData();
    formData.append('resetForm', JSON.stringify({ 'old_password': oldPassword, 'new_password': password }));
    try {
      const response = await apiClient.post(
        `/auth/change-password`, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',

          }
        }
      );

      setToastMessage(response.data['message']);
      setShowToast(true);
      auth.signout(() => navigate("/"));


    } catch (error) {
      const message = handleAPIError(error);
      if (message) {
        setToastMessage(message);
        setShowToast(true);
        return
      }
    } finally {
      setLoading(false);
    }

  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <ToastContainer className="p-3" position='top-center'>
        <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

      <h4 className="mb-4">{t("SettingsChangePassword.change_password")}</h4>

      <Form.Group className='mt-4'>
        <Form.Control
          id="oldPassword"
          type="password"
          placeholder={t("SettingsChangePassword.old_password")}
          className="form-icon-input"
          onChange={handleInputOldPwd}
          isInvalid={!!errors.oldPassword}

        />
        <Form.Control.Feedback type="invalid">
          {errors.oldPassword}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group className='mt-4'>
        <Form.Control
          id="password"
          type="password"
          placeholder={t("SettingsChangePassword.new_password")}
          className="form-icon-input"
          onChange={handleInputChangePwd1}
          isInvalid={!!errors.password}
        />
        <Form.Control.Feedback type="invalid">
          {errors.password}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group className='mt-4'>
        <Form.Control
          id="newPassword2"
          type="password"
          placeholder={t("SettingsChangePassword.confirm_password")}
          className="form-icon-input"
          onChange={handleInputChangePwd2}
          isInvalid={!!errors.password2}

        />
        <Form.Control.Feedback type="invalid">
          {errors.password2}
        </Form.Control.Feedback>
      </Form.Group>

      <Button variant="primary" className="mt-4 mb-3" onClick={handleSubmit}>
        {t("SettingsChangePassword.change_password")}
      </Button>
    </>
  );
};

export default SettingsChangePassword;
